export default {
    translation: {
        "Ürün Yönetimi": "Produkt Management",
        "Anasayfa": "Startseite ",
        "Hızlı Satış": "Schnell Verkauf",
        "Çalışan ve Maaşlar": "Beschäftigung und Gehalt ",
        "Tüm Ürünler": "Alle Produkte ",
        "Gelecek Ürünler": "Kommende Produkte ",
        "Silinen Ürünler": "Gelöschte Produkte ",
        "Kiradaki Ürünler": "Produkte zu vermieten",
        "Terzideki Ürünler": "Produkte beim Schneider ",
        "Kuru Temizlemedeki Ürünler": "Trockenreinigungsprodukte",
        "Yeni Ürün Siparişi": "neue Produktbestellung ",
        "Kasa": "die Kasse",
        "Günlük Kasa": "Tages Kasse",
        "Geçmiş Gün Sonları": "vergangene Tage",
        "Genel Giderler": "Gemeinkosten",
        "Cari Yönetimi": "aktuelle Geschäftsführung",
        "Yeni Cari": "neue Kunden ",
        "Cari Listele": "Kundenliste",
        "Cari İşlemleri": "Kundentransaktion",
        "Raporlar": "Berichte",
        "Satış Raporları": "Verkaufsberichte",
        "Ürün Raporları": "Produktberichte",
        "Gelir Gider Raporları": "Einnahmen-Ausgaben Berichte",
        "Çalışan Raporları": "Arbeitsberichte",
        "Provalar": "Proben",
        "Prova Takvimi": "Probenkalender",
        "Liste Görünüm": "Listenansicht",
        "Kuaför Randevuları": "Friseur Termine",
        "Kuaför Takvimi": "Friseur Kalender",
        "SMS Modülü": "SMS Modul",
        "Tanımlamalar": "Definitionen",
        "Ayarlar": "Die Einstellungen",
        "Duyurular": "Ankündigung",
        "Yeni Duyuru Ekle": "Neue Ankündigung hinzufügen",
        "Henüz hiç müşteri eklememişsiniz, hemen yeni bir tane ekleyin!": "Sie haben noch keine Kunden hinzufügt, fügen sie jetzt einen neuen hinzu !",
        "Duyuruyu Güncelle": "Aktualisieren sie die Ankündigung",
        "Sil": "löschen",
        "Vazgeç": "aufgeben",
        "Ekle": "hinzufügen",
        "Kaydet": "Speichern",
        "Başlık": "Titel",
        "Tarih": "Datum",
        "Randevular": "Termine",
        "Randevu Kaydı": "Terminaufzeichnung",
        "Müşteri Seçimi": "Kundenwahl",
        "Ürün / Hizmet Seçimi": "Produkt / Dienst Wahl",
        "Başlangıç Tarihi": "Anfangsdatum",
        "Başlangıç Saati": "Startzeit",
        "Bitiş Tarihi": "Endtermine",
        "Bitiş Saati": "Endzeit",
        "Bildirim SMS'i Gönder": "SMS- Benachrichtigung senden",
        "Randevu Detayı": "Termindetails",
        "İlgili Calışan": "Zuständiger Mitarbeiter",
        "Başlangıç Zamanı": "Startzeit",
        "Bitiş Zamanı": "Endzeit",
        "İlgili Hizmetler": "zuständige Dienstleistung",
        "Etkinliği Sil": "Aktivität löschen",
        "Yeni Ürün Oluştur": "Neues Produkt erstellen",
        "Barkod": "Barcode",
        "Birim": "Einheit ",
        "Henüz hiç randevu oluşturmamışsınız, hemen yeni bir tane ekleyin!": "Sie haben noch keine Termine erstellt, fügen Sie jetzt einen neuen hinzu!",
        "SMS ile Hatırlat": "Per SMS erinnern",
        "Tamamla": "Komplett",
        "Mesaj": "Nachricht",
        "SMS Gönder": "SMS senden",
        "TL Borcumuz Mevcut": "TL Schulden sind erhältlich",
        "TL Ara Ödeme Yapıldı": "TL Zwischenzahlung geleistet",
        "TL Alacak Mevcut": "TL Forderungen vorhanden",
        "Ara Ödeme": "Zwischen Zahlung",
        "İşlem Oluştur": "Aktion erstellen",
        "GELİR": "Einkommen",
        "GİDER": "Kosten",
        "ALACAK": "Guthaben",
        "Görüntüle": "Ansicht",
        "İptal": "Abbrechen",
        "Gönder": "schicken",

        "Fatura No": "Rechnungsnummer",
        "Kategori": "Kategorie",
        "Ödeme Tarihi": "Zahlungsdatum",
        "Ödeme Türü": "Zahlungsart",
        "Ürün / Hizmet": "Produkt / Bedienung",
        "Birim Fiyatı": "Einzelpreis",
        "KDV Oranı": "Mehrwertsteuersatz",
        "İskonto": "Rabatt",
        "Adet": "Anzahl",
        "Toplam KDV": "Gesamtumsatzsteuer",
        "Toplam Fiyat": "Gesamtpreis",
        "Kapat": "schließen",
        "Kayıt Oluştur": "Registrieren",
        "Ad Soyad": "Vorname, Nachname",
        "Telefon Numarası": "Telefonnummer",
        "Ünvan": "Titel",
        "Vergi Dairesi": "Steuerverwaltung",
        "Vergi No": "Steuernummer",
        "TC Kimlik No": "TC - Identifikationsnummer",
        "E-mail": "E-mail",
        "Firma Adı": "Name der Firma",
        "İl": "Provinz",
        "İlçe": "Landkreis",
        "Adres": "Adresse",
        "Hesap Adı": "Kontobezeichnung",
        "Banka Adı": "Bank Name ",
        "Şube Adı": "Zweigname",
        "Şube Kodu": "Branchencode",
        "Hesap No": "Kontonummer",
        "Döviz": "Währung",
        "IBAN": "IBAN",
        "Yeni Hesap Ekle": "Neues Konto hinzufügen",
        "Müşteriler": "Kunden",
        "Filtreleri Temizle": "klare Filter",
        "Yeni Müşteri Ekle": "Neuen Kunden hinzufügen",
        "Henüz hiç müşteri eklememişsiniz, hemen yeni bir tane ekleyin": "Sie haben noch keine Kunden hinzugefügt, fügen Sie jetzt einen neuen hinzu",
        "Alacaklı": "Zahlungsempfänger",
        "Borçlu": "Schuldner",
        "Bilgileri Güncelle": "Informationen aktualisieren",
        "Limitsiz için": "für unbegrenzt",
        "Terzi Fişi": "Schneiderstecker",
        "Ayarları Kaydet": "Einstellungen speichern",
        "Satış Sözleşmesi": "Kaufvertrag",
        "Sipariş Sözleşmesi": "Vertrag bestellen",
        "Kira Sözleşmesi": "Mietvertrag",
        "Kuru Temizleme Fişi": "Trockenreinigung Stecker",
        "Yeni Oluştur": "Erstelle neu",
        "Henüz hiç kategori eklememişsiniz, hemen yeni bir tane ekleyin": "Sie haben noch keine Kategorien hinzufügt, fügen sie jetzt eine neue hinzu",
        "Tüm Çalışanlar": "Alle Mitarbeiter",
        "Çalışan Oluştur": "Mitarbeiter anlegen",
        "İzinde": "ist im Urlaub",
        "İzin Geçmişi": "Überfällig",
        "Maaşı Öde": "Gehalt zahlen",
        "Avans Öde": "Vorschuss zahlen",
        "Güncelle": "aktualisieren",
        "Ücret": "Gebühr",
        "Ödeme Yap": "Zahlen",
        "Henüz hiçbir kayıt girmemişsiniz": "Sie haben noch keine Eingaben gemacht",
        "Şahıs Bilgileri": "Persönliche Angaben",
        "Kan Grubu": "Blutgruppe",
        "Ise Giris Tarihi": "Arbeitsbeginn",
        "Maasi": "Lohn",
        "Iletisim Bilgileri": "Kontaktinformationen",
        "E-mail Adresi": "E-mail Adresse",
        "Satış Personeli": "Verkaufspersonal",
        "Stoku azalan ürünler": "Produkte ausverkauft",
        "Henüz bir şey eklenmemiş": "Es wurde noch nichts hinzugefügt",
        "ciro": "Giro",
        "Adet Kirada": "Auf Miete",
        "Adet Terzide": "Beim Schneider",
        "Adet Kuru Temizlemede": "Bei der Trockenreinigung",
        "Kira Takvimi": "Mietkalender",
        "Kiraya Ver": "Vermieten",
        "Düzenle": "Bearbeiten",
        "S.No": "Seriennummer",
        "Kiraya Verilen Kişi": "Kunde im Leasing",
        "Kiraya Verilen Tarih":"Mietdatum",
        "Teslim Alınan Tarih": "Datum der Ankunft",
        "Tutar": "Menge",
        "Durum": "Durum",
        "girin": "girin",
        "Satış Fiyatı": "Verkaufspreis",
        "Kira Fiyatı": "Mietpreis",
        "Yazdır": "Unterdrücken",
        "Kuru Temizleme Seçimi": "Auswahl der Trockenreinigung",
        "Ürün Seç": "Produktauswahl",
        "Oluştur": "erschaffen",
        "Kuru Temizleme Sözleşmesi İndir": "Laden Sie den Reinigungsvertrag herunter",
        "Kuru Temizlemeye Ürün Gönder": "Senden Sie das Produkt zur chemischen Reinigung",
        "Kuru Temizleme Notu": "Hinweis zur chemischen Reinigung",
        "Kuru Temizleme Oluştur": "Erstellen Sie eine chemische Reinigung",
        "GSM": "Telefon",
        "2. GSM": "2. Telefon",
        "Terzi Seçimi": "Wahl des Schneiders",
        "Terzi Sözleşmesi İndir": "Laden Sie den Schneidervertrag herunter",
        "Teslim Al": "Lieferung bekommen",
        "Ödenen Tutar": "Gezahlter Betrag",
        "Teslim alınan tarih": "Liefertermin",
        "Bu kiranın (varsa) kalan ödemelerini tamamla": "Vervollständigen Sie die restlichen Zahlungen dieses Mietvertrags (falls vorhanden)",

        "Gelecek Ürün Ekle": "Nächstes Produkt hinzufügen",
        "Limitsiz": "Unbegrenzt",
        "Alış Tarihi": "Kaufdatum",
        "Teslim Tarihi": "Liefertermin",
        "Toplam Ücret": "Gesamtgebühr",
        "Peşinat": "Vorauszahlung",
        "Notlar": "Anmerkungen",
        "İçeri Al": "Importieren",
        "Stok": "Lager",
        "Gelecek Stok": "Gelecek Stok",
        "Kira Fiyatı Barkodda Görünsün": "Lassen Sie den Mietpreis im Barcode erscheinen",
        "Terziye Ürün Gönder": "Senden Sie das Produkt an den Schneider",
        "Toplam Genel Gider": "Gesamtausgaben",
        "İşlem Sayısı": "Anzahl der Transaktionen",
        'Ödeme Şekli': 'Zahlungsmethode',
        "BORÇ": "Schulden",
        "Ödeme Alındı": "Zahlung ist abgeschlossen",
        "Ödeme Tamamla": "komplette Restzahlung",
        "Personel Raporları": "Personalberichte",
        "Toplam Çalışan": "Gesamtzahl der Mitarbeiter",
        "Çalışanların Toplam Satış Geliri": "Gesamteinkommen der Arbeitnehmer",
        "Çalışanların Toplam Kira Geliri": "Gesamtmieteinnahmen der Mitarbeiter",
        "Çalışanların Bu Yılki İzinleri": "Arbeitnehmerurlaub in diesem Jahr",
        "Sonraki Fatura Tarihi": "Nächstes Rechnungsdatum",
        "Sonraki Vade": "Nächstes Semester",
        "Gelir Gider Raporlar": "Einnahmen-Ausgaben-Berichte",
        "Gelir": "Einkommen",
        "Gider": "Aufwand",
        "Gelire Dönüştür": "in Einkommen umwandeln",
        "Toplam Gelir": "Gesamteinnahmen",
        "Toplam Gider": "Toplam Gider",
        "NET KÂR": "REINGEWINN",
        "Cari Kayıtları": "Kundendatensätze",
        'Tümü': 'Jeder',
        'Nakit': 'Geld',
        'Çek': 'Überprüfen',
        'Senet': 'Senet',
        'Kredi Kartı': 'Kreditkarte',
        'Havale / EFT': 'Überweisung ',

        "Toplam Kira Adedi": "Gesamtzahl der Anmietungen",
        "Toplam Kira Geliri": "Gesamtmieteinnahmen",
        "Toplam Satış Adedi": "Gesamtzahl der Verkäufe",
        "Toplam Satış Geliri": "Gesamtumsatz",
        "Kullanıcı Bilgileri": "Nutzerinformation",
        "Telefon": "Telefon",
        "SMS Ayarları": "SMS-Einstellungen",
        "Bulutfon panelinde Ayarlar > API Kullanıcıları bölümünden bir kullanıcı oluşturup API Key'i giriniz.": "Erstellen Sie einen Benutzer im Abschnitt API-Benutzer und geben Sie den API-Schlüssel ein.",
        "NetGSM paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.": "NetGSM Geben Sie Ihren Benutzernamen und Ihr Passwort ein, mit denen Sie sich beim Panel angemeldet haben.",
        "IletiMerkezi panelinden Ayarlar bölümünden aldığınız API bilgilerini giriniz.": "Geben Sie die API-Informationen ein, die Sie im Bereich „Einstellungen“ des Bedienfelds erhalten.",
        "JetSMS paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.": "JetSMS Geben Sie die API-Informationen ein, die Sie im Bereich „Einstellungen“ des Bedienfelds erhalten..",
        "SMSVitrini paneline girişte kullandığınız kullanıcı adı ve şifrenizi giriniz.": "SMSVitrini Geben Sie die API-Informationen ein, die Sie im Bereich „Einstellungen“ des Bedienfelds erhalten.",
        "OrganikSMS panelinden oluşturduğunuz API kullanıcısına ait API Key'i giriniz.": "OrganikSMS Geben Sie die API-Informationen ein, die Sie im Bereich „Einstellungen“ des Bedienfelds erhalten.",
        "Servis Sağlayıcı":"Dienstleister",
        "SMS Başlığı":"SMS-Header",
        "API Key":"API-Schlüssel",
        "Kullanıcı Adı":"Nutzername",
        "Şifre":"Passwort",
        "Secret (Gizli Şifre)":"Secret (Gizli Şifre)",
        "Firma Bilgileri":"Firmeninformation",
        "Şifreyi Değiştir":"Passwort ändern",
        "Kullanıcılar":"Kullanıcılar",
        "Eski Şifre":"Altes Passwort",
        "Yeni Şifre":"Neues Kennwort",
        "Yeni Şifre Tekrar":"Neues Passwort nochmal",
        "Şifre Değiştir":"Şifre Değiştir",
        "Şifreyi Güncelle":"Passwort erneuern",
        "Mağaza Lisans Numaranız:":"Ihre Shop-Lizenznummer:",
        "tarihinden beri":"seit dieser Zeit",
        "sistemi kullanıyorsunuz.":"Sie verwenden das System.",
        "Yetkili Kişi":"Berechtigte Person",
        "Yetkili Telefon":"Autorisiertes Telefon",
        "Kodu Tekrar Gönder":"Code erneut senden",
        "Telefonu Doğrula":"Telefon bestätigen",
        "Adres Bilgileri":"Adressinfo",
        "Çıktı Ayarları":"Ausgabeeinstellungen",
        "Barkod'da Satış Fiyatını Yazdır":"Verkaufspreis in Barcode drucken",
        "Barkod'da Kira Fiyatını Yazdır":"Drucken Sie den Mietpreis in Barcode",
        "Barkod'da Mağaza Logosunu Yazdır":"Ladenlogo auf Barcode drucken",
        "Satış Ve Kiralamada Otomatik Sms Gönder":"Senden Sie automatische SMS für Verkauf und Vermietung",
        "seçildi":"gewählt",
        "Tümünü seç":"Wählen Sie Alle",
        "SMS MODÜLÜ":"SMS-MODUL",
        "Toptan Ürünler":"Großhandelsprodukte",
        "Adet Aktif Sipariş":"Menge Aktiver Auftrag",
        "Görselleri Görüntüle":"Bilder anzeigen",
        "Sipariş Ver":"sipariş",
        "Görsel":"Bild",
        "Satış Fiyatına KDV Dahil":"Mehrwertsteuer im Verkaufspreis enthalten",
        "Not":"Notiz",
        "Ürün Siparişleri":"Produktbestellungen",
        "Değer":"Wert",
        "Adresi":"die Anschrift",
        'Bu hafta':'Diese Woche',
        'Bu ay':'Diesen Monat',
        'Tarih seç':'TDatum wählen',
        "Bugünkü Provalar":"Die heutigen Proben",
        "Bugün hiç prova yok":"Heute keine Proben",
        "Hatırlat":"erinnere mich",
        "Yaklaşan Borçlar":"Anstehende Schulden",
        "Hiç yaklaşan borcunuz yok":"Sie haben keine anstehenden Schulden",
        "Bugun Kiraya Verilecek Ürünler":"Artikel zu mieten heute",
        "Bugun Kiraya Verilecek Ürün Yok":"Heute keine Artikel zu mieten",
        "Bugun Kiradan Teslim Alınacak Ürünler":"Produkte, die noch heute von der Vermietung geliefert werden",
        "Bugun alınacak Ürün Yok":"Heute keine Artikel zu kaufen",
        "BUGÜN:":"HEUTE:",
        "TESLİMAT":"TESLİMAT",
        "KİRADA OLAN":"VERMIETET",
        "KURU TEMİZLEME":"TROCKENREINIGER",
        "TERZİ":"SCHNEIDER",
        "KREDİ":"KREDİt",
        "Kredi":"KREDİt",
        "Uygun Satış Personeli Bulunamadı":"Keine geeigneten Vertriebsmitarbeiter gefunden",
        "İade Tarih":"Rückflugdatum",
        "Düğün Tarihi":"Düğün Tarihi",
        "Fotoğraf Çekim Tarihi Tarihi":"Fotoğraf Çekim Tarihi",
        "Ödeme Tipi":"Zahlungsart",
        "Ürün Ekle":"Produkt hinzufügen",
        "Toplam":"Gesamt",
        "Sözleşmesi İndir":"Vertrag herunterladen",
        "Sipariş Sözleşmesi İndir":"Bestellvertrag herunterladen",


        'Lütfen Önce Müşteri Seçiniz!': 'Lütfen Önce Müşteri Seçiniz!',
        "Müşteri": "Müşteri",
        "Ürün": "Ürün",
        "Kuaför Randevu Kaydı": "Kuaför Randevu Kaydı",
        "Kâr": "Kâr",
        "Yeni İşlem Sayısı": "Yeni İşlem Sayısı",
        "Göğüs": "Göğüs",
        "Göğüs Üstü": "Göğüs Üstü",
        "Bel": "Bel",
        "Kol Boyu": "Kol Boyu",
        "Pazu": "Pazu",
        "Bilek": "Bilek",
        "Topuk Boyu": "Topuk Boyu",
        "Gelinin Boyu": "Gelinin Boyu",
        "Sipariş Notu": "Sipariş Notu",
        "Müşteri Oluştur": "Müşteri Oluştur",
        "GSM(Yakını)": "GSM(Yakını)",
        "Açıklama": "Açıklama",
        "Sipariş Ölçü Bilgileri": "Sipariş Ölçü Bilgileri",
        'Ürün Adı': 'Ürün Adı',
        'KDV': 'KDV',
        'İndirim(Tutar)': 'İndirim(Tutar)',
        'İndirim(Oran)': 'İndirim(Oran)',
        'Maaş': 'Maaş',
        'Kalan Ödeme': 'Kalan Ödeme',
        'Saat': 'Saat',
        'Son Ödeme': 'Son Ödeme',
        "Alış Fiyatı": "Alış Fiyatı",
        "Kira Getirisi": "Kira Getirisi",

        "Verilen Tarih": "Verilen Tarih",
        "Teslim Alınacak Tarih": "Teslim Alınacak Tarih",
        "Son Ödeme Tarihi":"Son Ödeme Tarihi",
        "Damat Bilgileri":"Damat Bilgileri",
        "Damat Telefonu":"Damat Telefonu",
        "Damat Ad Soyad":"Damat Ad Soyad",
        "Sistem Yetkilisi (Bayileri İzleyebilir ve Süper Yetkilidir)":"Sistem Yetkilisi (Bayileri İzleyebilir ve Süper Yetkilidir)",

    }
}